import React, { useEffect, useRef, useState } from 'react'
import Hexapi from '../../utility/HexAPI/Hexapi'
import { useSelector } from 'react-redux';
import Meetingheader from './Meetingheader';
import Meetinglist from './Meetinglist';
import Loader from '../../components/loader/Loader';
import "./meeting.css"
import { useMemo } from 'react';
import Meetingdetails from './Meetingdetails';
import Meetinginfo from './Meetinginfo';
import { LuPlus } from 'react-icons/lu';
import { useNavigate } from 'react-router';
import Editmeeting from './addmeeting/Editmeeting';

const Meetings = () => {
  const intervalRef = useRef(null);
  const user = useSelector(state => state?.users?.data?.[""]?.[0]);
  const userid = user?.empid ?? null;
  const [mode, setmode] = useState(0);
  const [searching, setSearching] = useState(false);
  const [search, setSearch] = useState("");
  const [meetingID, setMeetingID] = useState(null);
  const [detailsloading,setDetailsLoading] = useState(false)
  const [loading, setLoading] = useState(false);
  const [pendingMeetings, setPendingMeetings] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [closedMeetings, setClosedMeetings] = useState([]);
  const [isInfo,setisInfo] = useState(false)
  const [meetingAction,setmeetingAction] = useState([])
  const [meetingInfo,setmeetingInfo] = useState(null)
  const[details,setDetails] = useState(null)
  const [isAttendee,setisAttendee] = useState([])
  const latestModeRef = useRef(mode);
  const navigate=useNavigate()
  const [showadd,setshowadd]=useState(false)
  const addMeeting =()=>{
// navigate("/addmeeting")
setshowadd(true)
        }

const callapichat = async (ishard) => {
  try {
    const ticketList = "MeetingList";
    const obj = {
      query: `[dbo].[HRApp_Web_Proc_User_Notification_Check] @UserID ='{0}',@Screen='{1}'`,
      queryArr: [`${userid}`, `${ticketList}`]
    };

    const resp = await Hexapi(obj);

    if (resp && resp[""] && resp[""][0] && !ishard) {

      const command = resp[""][0].command;
      const alert = resp[""][0].alert;

     
      if (command == 1 && alert == 1) {

        getMeetingListData(true);

       
        if (meetingID) {
          getMeetingDetails(true);
        }

      }
    }

    if(ishard){
      getMeetingListData(true);
        if (meetingID) {
          getMeetingDetails(true);
        }
    }
    const nextDelay = resp?.[""]?.[0]?.retrytime * 1000 ?? 5000;

    clearTimeout(intervalRef.current);

    intervalRef.current = setTimeout(() => callapichat(), nextDelay);

  } catch (error) {

    clearTimeout(intervalRef.current);

    intervalRef.current = setTimeout(() => callapichat(), 5000);

  }
};

useEffect(() => {

  if (!userid) return;

  callapichat(1);

  return () => {
    clearTimeout(intervalRef.current);
  };

}, [userid]);
  useEffect(() => {
  latestModeRef.current = mode;
}, [mode]);
  const getMeetingListData = async (ishidden =false) => {
  const currentMode = mode;

  const obj = {
    query: `HRApp_Droid_Proc_User_Meeting_GetList @UserID='{0}', @mode='{1}'`,
    queryArr: [`${userid}`, `${currentMode}`]
  };

  try {
    if(!ishidden){
setLoading(true);
    }
    

    const resp = await Hexapi(obj, () => getMeetingListData(ishidden), 1, 0);

    if (latestModeRef.current !== currentMode) {
      return;
    }

    const data = resp && resp[""] ? resp[""] : [];

    if (currentMode === 0) {
      setPendingMeetings(data);
    } else {
      setClosedMeetings(data);
    }

  } catch (error) {
    console.error("Meeting List Error:", error);
  } finally {
    if (latestModeRef.current === currentMode) {
      setLoading(false);
    }
  }
};
const currentList = mode === 0 ? pendingMeetings : closedMeetings;
const filteredMeetings = useMemo(() => {
  return currentList.filter(item => {
    if (!search.trim()) return true;
    return item?.name?.toLowerCase().includes(search.toLowerCase());
  });
}, [currentList, search]);
  useEffect(() => {
    if (!userid) return;
    console.log("calllegruyfhijdbh")
    getMeetingListData();
  }, [userid, mode]);


  const GetMeetingid = async (id) => {
  setMeetingID(id)
    };


    const getMeetingDetails = async (ishidden = false) => {
      if(!meetingID) return
      if(!ishidden){
      setmeetingAction([])
      setmeetingInfo(null)
      setDetails(null)
      setDetailsLoading(true)
      }

        const obj = {
            query:`HRApp_Droid_Proc_User_Meeting_Information_GetValueV2 @MeetingID='{0}',@UserID='{1}'`,
            queryArr:[`${meetingID}`,`${userid}`]
        }
        const isdata=meetingID
        console.log(isdata)
        try {
            
            const resp = await Hexapi(obj,()=>getMeetingDetails(),1,0,meetingID)
            console.log(resp,"respsss")

            if(resp && resp.meetinginfo && resp.meetinginfo.length > 0){
                setmeetingInfo(resp.meetinginfo[0])
            }else{
                setmeetingInfo(null)
            }

            if(resp && resp.meetingactions && resp.meetingactions.length > 0){
                setmeetingAction(resp.meetingactions)
            }else{
                setmeetingAction([])
            }

            if(resp && resp[""] && resp[""]){
                setisAttendee(resp[""])

            }else{
                setisAttendee([])
            }

            if(resp && resp.attachments && resp.attachments.length > 0){
              console.log("fghjdkjsl")
                setAttachments(resp.attachments)
            }else{
                setAttachments([])
            }
        } catch (error) {
            console.error("Meeting Details Error:", error);
        } finally {
            setDetailsLoading(false)
        }
    }

    useEffect(()=>{
        if(meetingID && userid){
            getMeetingDetails()
        }
    },[meetingID])
  return (
    <div className='container-fluid' style={{borderTop:"1px solid #ddd" }}>
      <div className='row'>
        <div className='meeting-boxnew col-3' style={{position:"relative" , paddingLeft:"0px"}}>
          <div className="meeting-header-fixed" >
            <Meetingheader
              setmode={setmode}
              mode={mode}
              search={search}
              setSearch={setSearch}
              searching={searching}
              setSearching={setSearching}
            />
          </div>

          <div className="" >
            {loading ? (
              <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
                <Loader />
              </div>
            ) : filteredMeetings.length > 0 ? (
              <Meetinglist list={filteredMeetings}  GetMeetingDetails={(id)=>{GetMeetingid(id)}} meetingid={meetingID}/>
            ) : (
              <div
  className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}
>
  {search ? "No Search Results Found" : "No Meetings!"}
</div>
            )}
          </div>
          <div className='meetfloat'>
    <div 
                                                    style={{ display:   "flex" , zIndex: 1050 }}>
                                                    <div className='footsetsetgreen' onClick={() => {
                                                        addMeeting()
                                                    }}>
                                                        <p style={{ margin: 0 }}>Quick join</p>
        
                                                    </div>
                                                </div>
        <div 
                                                    style={{ display:   "flex" , zIndex: 1050 }}>
                                                    <div className='footsetsetmeet' onClick={() => {
                                                        addMeeting()
                                                    }}>
                                                        <p style={{ fontWeight: "bold", fontSize: "19px", margin: 0, display: "flex", alignItems: "center" }}>
                                                            <LuPlus size={20} />
                                                        </p>
                                                        <p style={{ margin: 0 }}>Meeting</p>
        
                                                    </div>
                                                </div>
  </div>
          <div>
            </div>

        </div>

        <div className={isInfo ? "col-6" : "col-9"} style={{padding:"10px", backgroundColor:"#f6f8fb"}}>
          <div className='meeting-box-right'>
           {
              detailsloading ? <div className="d-flex justify-content-center align-items-center"
  style={{  color: "#ff6d00",height:"70vh" }}>
                <Loader />
              </div> :
            meetingID ? <Meetingdetails attachments={attachments} getMeetingListData={(data)=>getMeetingListData(data)} GetMeetingDetails={(id)=>{getMeetingDetails(id)}} meetingAction={meetingAction} meetingInfo={meetingInfo} details={details} setisInfo={(data)=>setisInfo(data)} meetingid={meetingID}  userid={userid}/> : <div
  className="d-flex justify-content-center align-items-center"
  style={{ height: "87vh", color: "#ff6d00" }}>
  Select a meeting to view details
</div>
           }
          </div>
        </div>
{
  isInfo && <div className='col-3 meeting-box-rightinfo'>
<Meetinginfo  getMeetingListData={(data)=>getMeetingListData(data)} GetMeetingDetails={(id)=>{getMeetingDetails(id)}} userid={userid} setisInfo={(data)=>setisInfo(data)} isAttendee={isAttendee} info={meetingInfo}/>
    </div>
}

{
  showadd && <Editmeeting getMeetingListData={()=>getMeetingListData()} GetMeetingDetails={(id)=>{getMeetingDetails(id)}} show={showadd} hide={()=>setshowadd(false)}/>
}
      </div>
    </div>
  );
};

export default Meetings;
